import { useEffect } from 'react';
import './AuthErrorDialog.css';

interface AuthErrorDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export function AuthErrorDialog({ isOpen, onConfirm }: AuthErrorDialogProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="auth-error-dialog-overlay" onClick={onConfirm}>
      <div className="auth-error-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="auth-error-dialog__icon">⚠️</div>
        <h2 className="auth-error-dialog__title">세션이 만료되었습니다</h2>
        <p className="auth-error-dialog__message">
          로그인 세션이 만료되었거나 유효하지 않습니다.
          <br />
          다시 로그인해주세요.
        </p>
        <button
          className="auth-error-dialog__button"
          onClick={onConfirm}
          type="button"
        >
          확인
        </button>
      </div>
    </div>
  );
}

